import { HOST } from './anchors';

export const SUPPRESSED_ATTR = 'data-tour-suppressed';

export function suppressHostChrome(): HTMLElement[] {
  const hidden: HTMLElement[] = [];
  for (const selector of HOST.suppressDuringTour) {
    try {
      document.querySelectorAll(selector).forEach((el) => {
        el.setAttribute(SUPPRESSED_ATTR, '');
        hidden.push(el as HTMLElement);
      });
    } catch {
    }
  }
  return hidden;
}

export function restoreHostChrome(elements: HTMLElement[]): void {
  elements.forEach((el) => el.removeAttribute(SUPPRESSED_ATTR));
}
